import {AwpDmsInterfaceFactoryUtils} from '../../rest-api/awp-dms-interface-factory-utils';
import {SearchServiceOrdersRequest} from './search-service-orders-request';
import {SearchServiceOrdersRequestBody} from './search-service-orders-request-body';
import {SearchServiceOrdersFilter} from './search-service-orders-filter';

/**
 * Factory for creating SearchServiceOrders requests.
 */
export class AwpDmsInterfaceSearchServiceOrdersRequestFactory {
  createRequest(
    searchFilter: SearchServiceOrdersFilter,
    resultPartition: number,
    locale: string,
    dpNo: string,
    outletNo: string
  ): SearchServiceOrdersRequest {
    const request = new SearchServiceOrdersRequest();
    request.functionalHeader = AwpDmsInterfaceFactoryUtils.createFunctionalHeaderFromPrimitives(dpNo, outletNo);
    request.technicalHeader = AwpDmsInterfaceFactoryUtils.createTechnicalHeaderInRequest(
      'awp-dms-search-service-orders-request',
      '1.0.0'
    );
    request.userInformation = AwpDmsInterfaceFactoryUtils.createUserInformationFromPrimitive(locale);
    request.body = this.createRequestBody(searchFilter, resultPartition);
    return request;
  }

  private createRequestBody(
    searchFilter: SearchServiceOrdersFilter,
    resultPartition?: number
  ): SearchServiceOrdersRequestBody {
    const body = new SearchServiceOrdersRequestBody();
    body.searchFilter = searchFilter;
    if (resultPartition != null) {
      body.resultPartition = resultPartition;
    }
    return body;
  }
}
